import { syncController } from './useProjects';
import { openProjectSynced } from './openSynced';
import { isLiveSyncEnabled } from './liveSync';
import { useCurrentProject } from './currentProject';

/** Open a project by id, capturing the outgoing project's cover first. Shared by
 *  the Projects screen (click) + boot-from-permalink (`/p/<id>` route). The URL
 *  is kept in sync by a `useCurrentProject` subscription in main.tsx. */
export async function openProjectById(id: string): Promise<void> {
  const currentId = useCurrentProject.getState().projectId;
  if (currentId && currentId !== id) await syncController.captureCover(currentId);
  if (isLiveSyncEnabled()) await openProjectSynced(id);
  else await syncController.openProject(id);
}
